import { IFilter, IFilters, IFilterState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import {
  getUniqueListFromObject,
  PlaylistType,
  ScreenType
} from '../../utilities/utilities';
import {
  IFilterActions,
  IRestoreFilters,
  ISetAssetsFilters,
  ISetAssetsFiltersFirstTime,
  ISetMissingAssetsFilters,
  ISetPlaylistFilters,
  ISetPlaylistsFiltersFirstTime,
  ISetScreenFilters,
  ISetUserFilters,
  IUpdateFilters
} from '../actions/filterActions';
export const initialFilterState: IFilterState = {
  assets: {
    feeds: [],
    mediaType: [],
    status: [],
    state: [],
    action: []
  },
  screens: { type: [] },
  users: { screens: [] },
  agents: {},
  playlist: {
    customer: [],
    feed_name: [],
    action: [],
    play_on: [],
    skynet_status: []
  },
  missing_assets_cloud: {
    playlistVersion: [],
    playlistType: [],
    type: []
  },
  missing_assets_headend: {
    playlistVersion: [],
    playlistType: [],
    type: []
  }
};

const createFilterList = (
  arr: string[],
  itemMap: { [key: string]: string } // label to value map
) => {
  return arr.map(item => {
    return {
      label: item,
      value: itemMap[item] ? itemMap[item] : item,
      isSet: false
    };
  });
};

const updateFilterList = (
  oldFilters: IFilter[],
  newList: string[],
  newListMap: { [key: string]: string } // label to value map
) => {
  const updatedFilter = [];
  const oldFiltersList: string[] = oldFilters.map(filter => filter.label);
  newList.map((filterName: string) => {
    const index = oldFiltersList.indexOf(filterName);
    if (index === -1) {
      updatedFilter.push({
        label: filterName,
        isSet: false,
        value: newListMap[filterName] ? newListMap[filterName] : filterName
      });
    } else {
      updatedFilter.push(oldFilters[index]); // push the old filter
    }
  });
  return updatedFilter;
};

// func to extract unique key's value from the array of object
// compare the value with the previous state and then update if different

const setAssetFilters = (state: IFilterState, action: ISetAssetsFilters) => {
  const feedsList: string[] = [];
  action.payload.map((asset: any) => {
    asset.feeds.map((feedCode: string) => {
      const val = `${feedCode}#${asset.customer}`;
      if (feedsList.indexOf(val) === -1) {
        feedsList.push(val);
      }
    });
  });
  const mediaTypeList: string[] = getUniqueListFromObject(
    action.payload,
    'media_type'
  );
  const statusList: string[] = getUniqueListFromObject(
    action.payload,
    'skynet_status'
  );
  const stateList: string[] = getUniqueListFromObject(action.payload, 'state');
  const actionList: string[] = ['escalate', 'escalated', 'resolved'];
  const updatedState: IFilterState = { ...state };
  // update the filters
  // new feeds added to the list
  const assetFilters = updatedState.assets;
  assetFilters.feeds = updateFilterList(assetFilters.feeds, feedsList, {});
  assetFilters.mediaType = updateFilterList(
    assetFilters.mediaType,
    mediaTypeList,
    {}
  );
  assetFilters.status = updateFilterList(assetFilters.status, statusList, {});
  assetFilters.state = updateFilterList(assetFilters.state, stateList, {});
  assetFilters.action = updateFilterList(assetFilters.action, actionList, {});

  return { ...state, ...updatedState };
};

const setAssetsFiltersFirstTime = (
  state: IFilterState,
  action: ISetAssetsFiltersFirstTime
) => {
  const feedsList: string[] = [];
  action.payload.map((asset: any) => {
    asset.feeds.map((feedCode: string) => {
      const val = `${feedCode}#${asset.customer}`;
      if (feedsList.indexOf(val) === -1) {
        feedsList.push(val);
      }
    });
  });
  const mediaTypeList: string[] = getUniqueListFromObject(
    action.payload,
    'media_type'
  );
  const statusList: string[] = getUniqueListFromObject(
    action.payload,
    'skynet_status'
  );
  const stateList: string[] = getUniqueListFromObject(action.payload, 'state');
  const actionList: string[] = ['escalate', 'escalated', 'resolved'];
  const updatedState: IFilterState = { ...state };
  const assetFilters = updatedState.assets;
  // reset the filters
  assetFilters.feeds = createFilterList(feedsList, {});
  assetFilters.mediaType = createFilterList(mediaTypeList, {});
  assetFilters.status = createFilterList(statusList, {});
  assetFilters.state = createFilterList(stateList, {});
  assetFilters.action = createFilterList(actionList, {});
  return { ...state, ...updatedState };
};

const setMissingAssetFilters = (
  state: IFilterState,
  action: ISetMissingAssetsFilters
) => {
  const id = action.payload.playlistId;
  const appState = action.appState;
  const selectedPlaylist = appState.playlists.playlistMap[id];
  let missingCloudAssets = {};
  let missingHeadendAssets = {};
  if (
    selectedPlaylist &&
    selectedPlaylist.last_published &&
    selectedPlaylist.last_published.missing_list
  ) {
    missingCloudAssets = selectedPlaylist.last_published.missing_list.cloud;
    missingHeadendAssets =
      selectedPlaylist.last_published.missing_list.headends;
  }
  const versionCloudList: string[] = [];
  const assetTypeCloudList: string[] = [];
  if (Object.keys(missingCloudAssets).length !== 0) {
    Object.keys(missingCloudAssets).map(assetType => {
      if (missingCloudAssets[assetType].length !== 0) {
        if (assetTypeCloudList.indexOf(assetType) === -1) {
          assetTypeCloudList.push(assetType);
        }
        missingCloudAssets[assetType].map(row => {
          const version = Object.keys(row.playlist).join(', ');
          if (versionCloudList.indexOf(version) === -1) {
            versionCloudList.push(version);
          }
        });
      }
    });
  }
  const versionHeadendList: string[] = [];
  const assetTypeHeadendList: string[] = [];
  if (Object.keys(missingHeadendAssets).length !== 0) {
    Object.keys(missingHeadendAssets).map(assetType => {
      if (missingHeadendAssets[assetType].length !== 0) {
        if (assetTypeHeadendList.indexOf(assetType) === -1) {
          assetTypeHeadendList.push(assetType);
        }
        missingHeadendAssets[assetType].map(row => {
          const version = Object.keys(row.playlist).join(', ');
          if (versionHeadendList.indexOf(version) === -1) {
            versionHeadendList.push(version);
          }
        });
      }
    });
  }

  const updatedState: IFilterState = { ...state };
  // update the filters
  const assetFiltersCloud = updatedState.missing_assets_cloud;
  const assetFiltersHeadend = updatedState.missing_assets_headend;

  const playlistTypeList: string[] = [PlaylistType.BREAK, PlaylistType.NORMAL];

  assetFiltersCloud.playlistVersion = updateFilterList(
    assetFiltersCloud.playlistVersion,
    versionCloudList,
    {}
  );
  assetFiltersHeadend.playlistVersion = updateFilterList(
    assetFiltersHeadend.playlistVersion,
    versionHeadendList,
    {}
  );
  assetFiltersCloud.playlistType = updateFilterList(
    assetFiltersCloud.playlistType,
    playlistTypeList,
    {}
  );
  assetFiltersHeadend.playlistType = updateFilterList(
    assetFiltersHeadend.playlistType,
    playlistTypeList,
    {}
  );
  assetFiltersCloud.type = updateFilterList(
    assetFiltersCloud.type,
    assetTypeCloudList,
    {}
  );
  assetFiltersHeadend.type = updateFilterList(
    assetFiltersHeadend.type,
    assetTypeHeadendList,
    {}
  );

  return { ...state, ...updatedState };
};

const setScreenFilters = (state: IFilterState, action: ISetScreenFilters) => {
  const updatedState: IFilterState = { ...state };
  const screenTypeList: string[] = [
    ScreenType.INGEST,
    ScreenType.PLAYLIST,
    ScreenType.PLAYOUT
  ];
  const screenFilters: IFilters = updatedState.screens;
  screenFilters.type = screenTypeList.map(screen => {
    return {
      label: screen,
      value: screen,
      isSet: false
    };
  });
  return { ...state, ...updatedState };
};

const setUserFilters = (state: IFilterState, action: ISetUserFilters) => {
  const updatedState: IFilterState = { ...state };
  const userRoleList: string[] = getUniqueListFromObject(
    action.payload,
    'role'
  );

  const screenList: string[] = action.appState.screens.screenIds;
  const screenMap = action.appState.screens.screenMap;

  const userFilters: IFilters = updatedState.users;
  userFilters.screens = screenList.map(screen => {
    return {
      label: screenMap[screen].name,
      value: screen,
      isSet: false
    };
  });
  userFilters.role = userRoleList.map(role => {
    return {
      label: role,
      value: role,
      isSet: false
    };
  });
  userFilters.status = [
    {
      label: 'Active',
      value: true,
      isSet: false
    },
    {
      label: 'Not Active',
      value: false,
      isSet: false
    }
  ];
  return { ...state, ...updatedState };
};

const updateFilters = (state: IFilterState, action: IUpdateFilters) => {
  const updatedState = { ...state };
  const filterList = [...updatedState[action.filterType][action.filterName]];
  for (const i in filterList) {
    if (filterList[i].value === action.filter.value) {
      filterList[i].isSet = !filterList[i].isSet;
    }
  }
  updatedState[action.filterType][action.filterName] = filterList;
  localStorage.setItem('podFilters', JSON.stringify(updatedState));
  return { ...state, ...updatedState };
};

const restoreFilters = (state: IFilterState, action: IRestoreFilters) => {
  // go through all the filters and restore the value
  // check if the screen is valid
  const localFilter = JSON.parse(localStorage.getItem('podFilters'));
  const updatedState = { ...state };
  if (localFilter) {
    Object.keys(localFilter).map(filterType => {
      const filter = localFilter[filterType];
      Object.keys(filter).map(filterName => {
        const filterList = filter[filterName];
        if (updatedState[filterType][filterName]) {
          const filterLabels = updatedState[filterType][filterName].map(
            f => f.label
          );
          filterList.map(f => {
            const idx = filterLabels.indexOf(f.label);
            if (idx !== -1) {
              updatedState[filterType][filterName][idx] = f;
            }
          });
        }
      });
    });
  }
  return { ...state, ...updatedState };
};

const setPlaylistFilters = (
  state: IFilterState,
  action: ISetPlaylistFilters
) => {
  const updatedState: IFilterState = { ...state };
  const customerList: string[] = getUniqueListFromObject(
    action.payload,
    'customer'
  );
  const feedNameList: string[] = getUniqueListFromObject(
    action.payload,
    'feed_name'
  );
  const playOnList: string[] = getUniqueListFromObject(
    action.payload,
    'play_on'
  );
  const statusList: string[] = getUniqueListFromObject(
    action.payload,
    'skynet_status'
  );
  // update the filters
  // new feeds added to the list
  const playlistFilters = updatedState.playlist;
  playlistFilters.customer = updateFilterList(
    playlistFilters.customer,
    customerList,
    {}
  );
  playlistFilters.feed_name = updateFilterList(
    playlistFilters.feed_name,
    feedNameList,
    {}
  );
  playlistFilters.play_on = updateFilterList(
    playlistFilters.play_on,
    playOnList,
    {}
  );
  playlistFilters.skynet_status = updateFilterList(
    playlistFilters.skynet_status,
    statusList,
    {}
  );
  return { ...state, ...updatedState };
};

const setPlaylistFiltersFirstTime = (
  state: IFilterState,
  action: ISetPlaylistsFiltersFirstTime
) => {
  const updatedState: IFilterState = { ...state };
  const customerList: string[] = getUniqueListFromObject(
    action.payload,
    'customer'
  );
  const feedNameList: string[] = getUniqueListFromObject(
    action.payload,
    'feed_name'
  );
  const playOnList: string[] = getUniqueListFromObject(
    action.payload,
    'play_on'
  );
  const statusList: string[] = getUniqueListFromObject(
    action.payload,
    'skynet_status'
  );
  const playlistFilters = updatedState.playlist;
  const actionList: string[] = ['escalate', 'escalated', 'resolved'];
  playlistFilters.action = createFilterList(actionList, {});
  playlistFilters.customer = createFilterList(customerList, {});
  playlistFilters.feed_name = createFilterList(feedNameList, {}); // give feed codes
  playlistFilters.play_on = createFilterList(playOnList, {});
  playlistFilters.skynet_status = createFilterList(statusList, {});
  return { ...state, ...updatedState };
};

const filterReducer = (
  state = initialFilterState,
  action: IFilterActions
): IFilterState => {
  switch (action.type) {
    case actionTypes.SET_ASSETS_FILTERS:
      return setAssetFilters(state, action);
    case actionTypes.SET_ASSETS_FILTERS_FIRST_TIME:
      return setAssetsFiltersFirstTime(state, action);
    case actionTypes.SET_MISSING_ASSETS_FILTERS:
      return setMissingAssetFilters(state, action);
    case actionTypes.SET_SCREEN_FILTERS:
      return setScreenFilters(state, action);
    case actionTypes.SET_USER_FILTERS:
      return setUserFilters(state, action);
    case actionTypes.RESTORE_FILTERS:
      return restoreFilters(state, action);
    case actionTypes.UPDATE_FILTERS:
      return updateFilters(state, action);
    case actionTypes.SET_PLAYLIST_FILTER:
      return setPlaylistFilters(state, action);
    case actionTypes.SET_PLAYLISTS_FILTERS_FIRST_TIME:
      return setPlaylistFiltersFirstTime(state, action);
    default:
      return state;
  }
};

export default filterReducer;
